import { useEffect } from 'react';
import { Platform, BackHandler } from 'react-native';

export function useForbidBackAction(condition?: boolean) {
  // Prevent closing this screen using the Android Back button
  useEffect(() => {
    const backHandler = BackHandler.addEventListener('hardwareBackPress', () => condition && Platform.OS === 'android');
    return () => backHandler.remove();
  }, [condition]);
}
